
import { Row as RowBootstrap } from "styled-bootstrap-grid";
import styled from "styled-components";

export const Row = RowBootstrap;

export const RowJustify = styled(Row)`
  justify-content: ${({ justify }) => justify && justify};
`;
